import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class UserFreightRates {
  constructor($scope, $rootScope, UserFreightRateService, GeoService) {
    function load_data() {
      $scope.user_freight_rates = [];
      UserFreightRateService.get_user_freight_rates(window.user_id).success(function(data) {
        if (data.success)
          $scope.user_freight_rates = data.user_freight_rates;
      });
    }

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.$watch('dialog_rate.shipment_country_id', function() {
      if ($scope.dialog_rate.shipment_country_id) {
        GeoService.get_cities($scope.dialog_rate.shipment_country_id).then(function(data) {
          $scope.dialog_rate_shipment_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.dialog_rate.shipment_city_id}))
            $scope.dialog_rate.shipment_city_id = null;
        });
      }
    });

    $scope.$watch('dialog_rate.delivery_country_id', function() {
      if ($scope.dialog_rate.delivery_country_id) {
        GeoService.get_cities($scope.dialog_rate.delivery_country_id).then(function(data) {
          $scope.dialog_rate_delivery_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.dialog_rate.delivery_city_id}))
            $scope.dialog_rate.delivery_city_id = null;
        });
      }
    });

    $scope.add_freight_rate = function() {
      $scope.dialog_rate = angular.copy(window.freight_rate);
      $scope.open_dialog('user_freight_rate_dialog');
    };

    $scope.copy_freight_rate = function(rate) {
      $scope.dialog_rate = angular.copy(rate);
      $scope.dialog_rate.id = null;
      $scope.open_dialog('user_freight_rate_dialog');
    };

    $scope.edit_freight_rate = function(freight_rate) {
      $scope.dialog_rate = freight_rate;
      $scope.open_dialog('user_freight_rate_dialog');
    };

    $scope.delete_freight_rate = function(index) {
      if (confirm('Are you sure you want to delete this freight rate?')) {
        UserFreightRateService.delete($scope.user_freight_rates[index].id).then(function(data) {
          if (data.success) {
            $scope.user_freight_rates.splice(index, 1);
            $rootScope.$broadcast('set_sidebar_data', [0, 4, [{
              type: 'counter',
              value: $scope.user_freight_rates.length
            }]]);
          }
        });
      }
    };

    $scope.save_freight_rate = function() {
      $scope.updating_rate = true;
      UserFreightRateService.save($scope.dialog_rate).then(function(data) {
        if (data.success) {
          $scope.updating_rate = false;
          $.fancybox.close();
          $scope.user_freight_rates = data.user_freight_rates;
          $rootScope.$broadcast('set_sidebar_data', [0, 4, [{
            type: 'counter',
            value: $scope.user_freight_rates.length
          }]]);
        }
      });
    };

    $scope.$on('load_freight_rates', function() {
      load_data();
    });

    $scope.init = function() {
      $scope.delivery_terms = window.delivery_terms;
      $scope.countries = window.countries;
      $scope.currencies = window.currencies;
      $scope.user_id = window.user_id;
      $scope.dialog_rate = angular.copy(window.freight_rate);
      load_data();
    };

    $scope.init();

  }
}

UserFreightRates.$inject = ['$scope', '$rootScope', 'UserFreightRateService', 'GeoService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-freight-rates.ctrl.js